(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.controller('ProfileControllerV2', ["$scope", "$routeParams", "widgetPolling", "path", "objectTypeDao", "modulesDao", "$q", "defaultHttpErrorHandler", "openAppStatusListener", "$templateCache", "emailView", "$route", "modulesManager", "fileDao", function ($scope, $routeParams, widgetPolling, path, objectTypeDao, modulesDao, $q, defaultHttpErrorHandler, openAppStatusListener, $templateCache, emailView, $route, modulesManager, fileDao) {
        var widgetsScope = {
            entityType: $routeParams.entityType,
            id: $routeParams.id,
            titlePrefix: ''
        };
        $scope.shared = widgetsScope;
        var autoEntityLabel = _($routeParams.entityType.split('_')).last();
        autoEntityLabel = autoEntityLabel.charAt(0).toUpperCase() + autoEntityLabel.slice(1);
        var jsonTitle = '';
        var titleIcon = '';
        var downloadTestResponse;
        $route.current.title = autoEntityLabel;
        var loader = 'json';
        var widgetsPath = 'entity/' + widgetsScope.entityType;
        var profileTemplate = path('gui-v2').directive('profile').template(widgetsScope.entityType + '/' + widgetsScope.entityType);
        if ($templateCache.get(profileTemplate)) {
            loader = 'template';
        }
        var commonQueries = [
            objectTypeDao.retrieve().then(function (response) {
                widgetsScope.objectTypes = response;
            }),
            modulesManager.init()
        ];
        var customJsonExists = false;
        if (loader === 'json') {
            commonQueries.push(path('gui-v2').ctrl('profile-v2').json('entity/' + widgetsScope.entityType).retrieve(true).onRequestFail(function () {
                return $q.when({});
            }).then(function (response) {
                if (response.data) {
                    if (response.data.title) {
                        jsonTitle = response.data.title;
                        $route.current.title = jsonTitle;
                    }
                    customJsonExists = true;
                }
            }));
        }
        commonQueries.push(fileDao.downloadMatchedCheck(widgetsScope.id, widgetsScope.entityType).then(function (response) {
            widgetsScope.downloadTestResponse = response;
        }));
        $q.all(commonQueries).then(function (responses) {
            var saasByEntityType = widgetsScope.objectTypes.data && widgetsScope.objectTypes.data.entities && widgetsScope.objectTypes.data.entities[widgetsScope.entityType] && widgetsScope.objectTypes.data.entities[widgetsScope.entityType].saas;
            var saasFixes = {
                'office365_mgmnt': 'office365_emails',
                'google_users': 'google_drive'
            };
            if (saasByEntityType) {
                widgetsScope.module = saasByEntityType;
                widgetsScope.saasName = saasFixes[widgetsScope.module] || widgetsScope.module;
                widgetsScope.saas = modulesManager.cloudApp(widgetsScope.saasName);
                titleIcon = '#' + JSON.stringify({
                    display: 'saas-icon',
                    saas: widgetsScope.saas,
                    path: _(widgetsScope.saas).isObject() ? widgetsScope.saas.img : '/assets/gui-v2/images/icons-round/generic.svg'
                });
                modulesManager.currentModule(widgetsScope.saasName);    //TODO: this line is for compatibility of v2 with v1
            }
            if (!customJsonExists && !saasByEntityType) {
                return $q.reject({ status: 404 });
            }
            return modulesDao.entityInfoRaw(widgetsScope.module, widgetsScope.entityType).then(function (rawEntityInfo) {
                widgetsScope.rawEntityInfo = rawEntityInfo;
                if (_(rawEntityInfo).isObject() && rawEntityInfo.properties) {
                    var internal_item_property = null;
                    _(rawEntityInfo.properties).find(function (val, key) {
                        if (val.shared_external_flag === true) {
                            internal_item_property = key;
                            return true;
                        }
                        return false;
                    });
                    widgetsScope.internal_item_property = internal_item_property;
                }
                if (customJsonExists || loader !== 'json') {
                    return;
                }
                if (rawEntityInfo.sec_type_connected && rawEntityInfo.sec_type_connected.length) {
                    widgetsPath = 'basic-scannable-profile';
                } else {
                    widgetsPath = 'basic-profile';
                }
            });
        }).then(function () {
            if (loader === 'json') {
                widgetsScope.widgetsPath = widgetsPath;
            } else {
                widgetsScope.profileTemplate = profileTemplate;
            }
            widgetsScope.titlePrefix = titleIcon + '#' + JSON.stringify({
                display: 'text',
                text: widgetsScope.rawEntityInfo && widgetsScope.rawEntityInfo.label || autoEntityLabel
            });
            if (jsonTitle) {
                $scope.title = titleIcon + jsonTitle;
            } else {
                $scope.title = widgetsScope.titlePrefix;
            }
            widgetPolling.scope(widgetsScope);
            $.extend($scope, widgetsScope);
            $scope.loader = loader;
        }, defaultHttpErrorHandler);
        var destroyAppStatusListener = openAppStatusListener($scope);
        var destroyEmailSourceViewListener = $scope.$on('view-email-source', function (event, data) {
            emailView.viewSource(data);
        });
        var destroyEmailRenderedViewListener = $scope.$on('view-email-rendered', function (event, data) {
            emailView.viewRendered(data);
        });
        $scope.$on('$destroy', function () {
            destroyAppStatusListener();
            destroyEmailSourceViewListener();
            destroyEmailRenderedViewListener();
        });
    }]);
}());